import {useCallback} from 'react';
import {Button, Flex} from 'antd';
import {FilterOutlined, HeartFilled, HeartOutlined, UnlockOutlined} from '@ant-design/icons';

import {modelListGridId, useStoredGridState} from '../../../../store/grid';
import {Search} from '../../../core/Search/Search';
import {ModelFilterState} from '../filter';

import styles from './ModelListTopButtons.module.scss';

export const ModelListTopButtons = ({
  handleFilterPanel,
  numberOfFilters,
  isExternalUser,
}: {
  handleFilterPanel: () => void;
  numberOfFilters: number;
  isExternalUser: boolean;
}) => {
  const gridState = useStoredGridState<ModelFilterState>(modelListGridId);

  const handleSearchChange = useCallback(
    (search: string) => {
      if (gridState.page !== 0) {
        gridState.setPage(0);
      }
      gridState.setSearch(search);
    },
    [gridState],
  );

  const displayMyModels = () => {
    if (gridState.viewMyModels) {
      gridState.setViewMyModels(false);
    } else {
      gridState.setViewMyModels(true);
    }
  };

  const toggleViewFavorites = () => {
    gridState.setViewFavorites(!gridState.viewFavorites);
  };

  return (
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '28px'}}>
      <div className={styles.topButtons}>
        <Flex vertical gap="26px">
          <Search
            placeholder="Type Model Name, Trial Number or MKV"
            value={gridState.search}
            onValueChange={handleSearchChange}
            tourId="model-list-search"
          />
        </Flex>
        {isExternalUser ? null : (
          <>
            <Button
              onClick={toggleViewFavorites}
              type="link"
              icon={
                gridState.viewFavorites ? (
                  <HeartFilled style={{color: '#00857c', strokeWidth: '2px'}} />
                ) : (
                  <HeartOutlined style={{strokeWidth: '2px'}} />
                )
              }
              style={{fontWeight: 'bold', color: gridState.viewFavorites ? '#00857c' : undefined}}
            >
              {gridState.viewFavorites ? 'View all models' : 'View Favorites'}
            </Button>

            <Button
              onClick={displayMyModels}
              type="link"
              icon={<UnlockOutlined style={{strokeWidth: '2px'}} />}
              style={{fontWeight: 'bold'}}
            >
              {gridState.viewMyModels ? 'View All Model Entries' : 'Models I Have Access To'}
            </Button>
          </>
        )}
      </div>
      {isExternalUser ? null : (
        <Flex align="center" gap="16px">
          <Button onClick={handleFilterPanel} type="link" icon={<FilterOutlined />} style={{fontWeight: 'bold'}}>
            <span data-tour-id="model-list-more-filters">More Filters ({numberOfFilters})</span>
          </Button>
        </Flex>
      )}
    </div>
  );
};
